import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import RfqQuoteNewState, { QuoteItems } from "@tJohnstonCompanies/Handlers/RfqQuote/RfqQuoteNewState";
import { Draft } from "immer";

const initialState: RfqQuoteNewState = {
    quoteItems: [],
};

const customQuotesState = createTypedReducerWithImmer(initialState, {
    "CustomQuotes/RfqQuoteNewState/SetQuoteNewState": (draft: Draft<RfqQuoteNewState>, action: { quoteItems: [] }) => {
        draft.quoteItems = action.quoteItems;
    },
});

(reducers as any).customQuotesState = customQuotesState;

export type CustomQuoteState = {
    customQuotesState: RfqQuoteNewState;
} & ApplicationState;

type Reducers = {
    customQuotesState: typeof customQuotesState;
};

export type customQuotesActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
